import { render } from "./NewLocationFullCard.vue?vue&type=template&id=129b7fa2"
import script from "./NewLocationFullCard.vue?vue&type=script&lang=js"
export * from "./NewLocationFullCard.vue?vue&type=script&lang=js"

import "./NewLocationFullCard.vue?vue&type=style&index=0&id=129b7fa2&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__